import { Box, Typography, Stack } from "@mui/material";
import {
  AttachMoney as MoneyIcon
} from "@mui/icons-material";

const ProfileSalaryInfo = ({ salary }) => (
  <Box>
    <Typography variant="h6" color="text.secondary" gutterBottom>
      Salary Information
    </Typography>
    <Stack spacing={1.5} pl={2}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <MoneyIcon color="action" sx={{ mr: 1.5 }} />
        <Typography>Salary: Rs. {salary}</Typography>
      </Box>
      
    </Stack>
  </Box>
);

export default ProfileSalaryInfo;
